import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';

/**
 * Группа опций
 * ```vue live
 <HseDropdownMenuGroup title="Group title">
 <HseDropdownMenuItem v-for="i in 3" :key="i">Item #{{i}}</HseDropdownMenuItem>
 </HseDropdownMenuGroup>
 ```
 */
var HseDropdownMenuGroup = /** @class */ (function (_super) {
    __extends(HseDropdownMenuGroup, _super);
    function HseDropdownMenuGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseDropdownMenuGroup.prototype, "title", void 0);
    HseDropdownMenuGroup = __decorate([
        Component({
            name: 'HseDropdownMenuGroup'
        })
    ], HseDropdownMenuGroup);
    return HseDropdownMenuGroup;
}(Vue));

export default HseDropdownMenuGroup;
